interface Props {
  label?: string;
  selectList?: string[];
}

const SelectButton = (props: Props) => {
  const { label, selectList = [] } = props;
  
  return (
    <div className='select-result-button'>
      <span className='select-result-button-label'>{label ? `${label  } :` : ''}</span>
      &nbsp;
      <span className='select-result-button-content'>
        {
          selectList?.length > 2 ? selectList?.length : selectList?.toString()
        }
      </span>
    </div>
  );
};

export default SelectButton;